import React, { useContext } from "react";
import "./Intro.css";
import Github from "../../img/github.png";
import LinkedIn from "../../img/linkedin.png";
import Leetcode from "../../img/LeetCode.png";
import Blob from "../../img/Vector1.png";
import Blob1 from "../../img/Vector2.png";
import Bot from "../../img/bot.png";
import Resume from "./Resume.pdf";
import { themeContext } from "../../Context";


const Intro = () => {

  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;


  return (
    <div className="intro">
    <div className="i-left">
      <div className="i-name">
          <span style={{ color: darkMode ? "white" : "" }}>Hii! I Am</span>

        <span>Faizullah</span>

        <span>Machine Learning Enthusiast And Django Developer</span>
        <a href={Resume} download>
          <button className=" button i-button">Resume</button>
        </a>

        <div className="i-icons">
          <a href="https://github.com/Faizullah9181">
            {" "}
            <img src={Github} alt="" />{" "}
          </a>
          <a href="https://linkedin.com/in/faizullah-0597271b9">
            <img src={LinkedIn} alt="" />
          </a>
          <a href="https://leetcode.com/Faizullah9181/">
            {" "}
            <img src={Leetcode} alt="" />
          </a>
        </div>
      </div>
    </div>
    <div className="i-right">
      <img src={Blob} alt="" />
      <img src={Blob1} alt="" />
      <img src={Bot} alt="" />
 
      <div className="blur" style={{ background: "rgb(238 210 255)" }}></div>
      <div
        className="blur"
        style={{
          background: "#C1F5FF",
          top: "17rem",
          width: "21rem",
          height: "11rem",
          left: "15rem",
        }}
      ></div>
    </div>
  </div>
  )
}

export default Intro